import * as PIXI from 'pixi.js';
import PianoUtil from '@/util/piano-util';
import { EngineAbstract } from '@/components/engine-abstract';
import game from '@/model/game';
import { WIDTH, HEIGHT } from '@/constants';
import { EVENT_BUS } from '@/model/event-bus';
import { GridBackground } from '@/components/grid-background';
import moment from 'moment';
const BORDER =1,
    BLACK_GEM_COLOR = game.settings.blackGemColor,
    WHITE_GEM_COLOR =  game.settings.whiteGemColor,
    GEM_HEIGHT = 30,
    SUSTAIN_TAIL_COLOR = game.settings.sustainTailColor,
    BACKGROUND_COLOR_SEQUENCE = game.settings.backgroundColorSequence;

export class Engine2D extends EngineAbstract {
    constructor({
        boundaries,
        chartHeight = HEIGHT,
        chartWidth,
        pianoKeyWidth,
        judgementLinePositionPx = 0,
        pxPerSecond = 300,
        notes = [],
        totalLengthBeats
    } = {}) {
        super();
        this.boundaries = boundaries;
        this.pianoKeyWidth = pianoKeyWidth;
        this.PADDING = -(chartWidth) / 2;
        this.noteSprites = [];
        this.barLines = [];
        this.scrollable = new PIXI.Container();
        this.judgementLinePositionPx = judgementLinePositionPx;
        this.pxPerSecond = pxPerSecond;
        this.chartHeight = chartHeight;
        this.chartWidth = chartWidth;
        this.createBackground();
        this.addChild(this.scrollable);
        this.renderBarlines(totalLengthBeats);
        this.renderNotes(notes.filter(n => n.pitch));
        EVENT_BUS.on('NOTE_HIT', (noteHit) => {
            const note = this.noteSprites.find(
                (wrapped) => wrapped.xmlNote.id === noteHit.id);
            console.debug('remove', noteHit.id, note.xmlNote)
            this.scrollable.removeChild(note.label);
        });
    }

    createBackground() {
        const bg = new GridBackground({
            boundaries: this.boundaries,
            keyWidth: this.pianoKeyWidth,
            PIANO_WIDTH: this.chartWidth,
            CHART_HEIGHT: this.chartHeight,
            BACKGROUND_COLOR_SEQUENCE,
            BORDER
        });
        bg.y = -this.chartHeight / 2;
        this.addChild(bg);
    }

    renderNotes(notes) {
        notes.forEach((note) => {
            const keyNumber = note.pianoNote;
            const isBlackKey = PianoUtil.isBlackKey(keyNumber);
            const whites = PianoUtil.whiteKeysBetween(this.boundaries.min, keyNumber);
            const sprite = PIXI.Sprite.from('public/images/gem.png');

            sprite.width = this.pianoKeyWidth;
            sprite.x = this.PADDING + whites * (this.pianoKeyWidth + BORDER)
            sprite.height = GEM_HEIGHT;
            if (isBlackKey) {
                sprite.tint = BLACK_GEM_COLOR;
                sprite.width *= 0.6;
                sprite.x -= sprite.width / 2;
            } else {
                sprite.tint = WHITE_GEM_COLOR;
            }
            sprite.y = -note.timeSeconds * this.pxPerSecond + this.chartHeight / 2 - GEM_HEIGHT - this.judgementLinePositionPx;
            // little sustain tail 
            const tail = PIXI.Sprite.from('public/images/gem.png');
            tail.width = this.pianoKeyWidth * 0.3;
            tail.height = note.durationSeconds * this.pxPerSecond;
            tail.y = -tail.height;
            tail.x = this.pianoKeyWidth/4;
            tail.tint = SUSTAIN_TAIL_COLOR;
            sprite.addChild(tail);
            
            this.noteSprites.push({
                xmlNote: note,
                label: sprite
            });
            
            this.scrollable.addChild(sprite);
            // debug
            const debug = new PIXI.Text(note.pitch.step);
            sprite.addChild(debug);
            debug.width*=2;
        })
    }

    renderBarlines(totalLengthBeats) {
        for (let i = 0; i < totalLengthBeats; i++) {
            const line = PIXI.Sprite.from('public/images/gradient.png');
            line.height = 2;
            line.width = this.chartWidth;
            line.time = i * game.beatIntervalSeconds;
            line.x = this.PADDING;
            line.y = -line.time * this.pxPerSecond + (this.chartHeight) / 2 - this.judgementLinePositionPx;
            const time = new PIXI.Text(moment(0).seconds(line.time).format('m:ss'));
            time.time = line.time;
            time.x = line.x + 20;
            time.y = line.y;
            this.barLines.push(time);
            this.barLines.push(line);
            this.scrollable.addChild(time);
            this.scrollable.addChild(line);
        }
    }

    update(currentTime) {
        this.scrollable.y = currentTime * this.pxPerSecond ;
    }
}